import { useRef, useContext, useState, useEffect } from 'react';

import styles from './AddVisitorsComponent.module.css'

import { GlobalContext } from "../../../contexts/globalContext";
import { ProjectDetailsContext } from '../../../contexts/projectDetailsContext';

import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import PopupBodyComponent from '../common/PopupBodyComponent';
import PopupBaseComponent from '../common/PopupBaseComponent';
import ClosePageButtonComponent from '../../commons/ClosePageButtonComponent'
import RightBodyComponent from '../common/RightBodyComponent';
import LeftBodyComponent from '../common/LeftBodyComponent';
import FooterButtonsComponent from '../common/FooterButtonsComponent';
import New_InputTextComponent from '../../keyboard/New_InputTextComponent';
import New_DropDownComponent from '../../keyboard/New_DropDownComponent';

import CountriesJson from '../../../graphics/country.json';
import membersAdd from '../../../graphics/Popups/Icon Members Add.png'


const AddVisitorsComponent = () => {

    const inputRefName = useRef()
    const inputRefEntitling = useRef()
    const inputRefCountry = useRef()

    const [input, setInput] = useState('');
    const [output, setOutput] = useState('');

    const { keyboardRef, selectedProject, socketRef, currentUser, setAlertMessage } = useContext(GlobalContext);
    const { setAddVisitors, setAddParticipants } = useContext(ProjectDetailsContext);

    function handleEmailAdd() {
        socketRef.current.emit("CREATE_USER_AND_ADD_TO_PROJECT", {
            projectId: selectedProject._id,
            userData: {
                "name": inputRefName.current.value,
                "email": output,
                "role": "VISITOR",
                "entitle": inputRefEntitling.current?.value ? inputRefEntitling.current.value : null,
                "country": inputRefCountry.current?.currentChoice?.value ? inputRefCountry.current.currentChoice.value : null,
                "creatorLocationId": currentUser.location ? currentUser.location : null
            }
        }, (callback) => {
            if (callback) {
                setAddVisitors(false)
                setAddParticipants(false)
                setAlertMessage({ type: "SUCCESS", message: "Member created and added to project successfully." });
            }
        })
        
    }

    const transformString = (str) => {
        return str.toLowerCase().replace(/\s+/g, '.');
    };

    useEffect(() => {
        setOutput(transformString(input))
    }, [input])


    return (
        <PopupBaseComponent>
            <PopupBodyComponent style={{ width: 2040, height: 880, top: "12%" }}>
                <ClosePageButtonComponent setClose={() => setAddVisitors(false)} />
                <LeftBodyComponent image={membersAdd} title="Add visitor to project" description="Create and add a new visitor." />
                <RightBodyComponent>
                    <div className={styles.title}>New Visitor</div>

                    <div className={styles.subTitle}>Name</div>
                    <New_InputTextComponent ref={inputRefName} onChange={() => setInput(inputRefName.current.value)} keyboardRef={keyboardRef} value=""
                        placeHolder="Enter name here" styleType='POPUP' width="1000px" fontSize="40px" height="80px" iconPosition="right" withDelete={true} icon={byPrefixAndName.fas["pen"]} />

                    <div className={styles.username}>Username (automatically created): {output}</div>

                    <div className={styles.subTitle}>Entitling</div>
                    <New_InputTextComponent ref={inputRefEntitling} keyboardRef={keyboardRef} value=""
                        placeHolder="Enter entitling here" styleType='POPUP' width="1000px" height="80px" fontSize="40px" iconPosition="right" withDelete={true} icon={byPrefixAndName.fas["pen"]} />

                    <div className={styles.subTitle}>Country</div>
                    <New_DropDownComponent options={CountriesJson} ref={inputRefCountry} keyboardRef={keyboardRef} value="" placeHolder="Choose country" iconPosition="right" withDelete={true}
                        styleType='POPUP' width="1000px" height="80px" fontSize="40px" />

                    <FooterButtonsComponent
                        lightText={"Add"}
                        lightClick={input === "" ? () => { } : handleEmailAdd}
                        isOpaque={input === ""}
                        darkClick={setAddVisitors}
                    />
                </RightBodyComponent>
            </PopupBodyComponent>

        </PopupBaseComponent>
    );

}

export default AddVisitorsComponent;